import { useId, useState, type ReactNode } from "react";
import { CaseReviewIcon } from "../field_review/CaseReviewIcon";

interface Props {
  label: string;
  collapsible?: boolean;
  className?: string;
  children: ReactNode;
}

/** Keeps the collection heading visible even when its last record is removed. */
export function RecordSection({ label, collapsible = false, className = "", children }: Props) {
  const id = useId();
  const [open, setOpen] = useState(true);
  if (!collapsible) return <section className={`cr-records ${className}`} aria-label={label}>{children}</section>;
  return <section className={`cr-records ${collapsible ? "cr-group" : ""} ${className}`} aria-label={label} data-open={open}>
    {collapsible && <button type="button" className="cr-group-head" aria-expanded={open} aria-controls={id}
      onClick={() => setOpen(!open)}>
      <CaseReviewIcon name="chevronDown" className="cr-group-chevron" />
      <span className="cr-group-label">{label}</span>
    </button>}
    <div id={id} hidden={collapsible && !open}>{children}</div>
  </section>;
}
